import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { SiteBranding } from 'parts';
import { Button } from 'components';
import { PAGES } from 'router/constants';
import './style.scss';

export const Landing: React.FC = () => (
  <div className="page-landing">
    <Layout className="page-landing__content">
      <Row>
        <Col lg={{ flex: '304px' }} md={{ flex: '100%' }} span={24}>
          <SiteBranding />
        </Col>
        <Col className="form-block" lg={{ flex: '1' }} span={24}>
          <Row className="form-block__header">
            <Col span={24}>
              <Typography.Title level={3}>Welcome to the United Premier Soccer League</Typography.Title>
            </Col>
            <Col span={24}>
              <Typography.Text>How would you like to get started?</Typography.Text>
            </Col>
          </Row>
          <div className="form-block__content landing-actions">
            <Link to={PAGES.PLAYER_REGISTRATION}>
              <Button size="large" block>
                I am a player/coach
              </Button>
            </Link>
            <Link to={PAGES.TEAM_REGISTRATION}>
              <Button size="large" block>
                I want to register a club/team
              </Button>
            </Link>
            <Link className="landing-actions__login" to={PAGES.SIGN_IN}>
              <Button size="large" type="default" block>
                I want to login
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
    </Layout>
  </div>
);
